export interface FetchRetryOptions {
  delaysMs: number[]
  shouldRetryResponse: (res: Response) => boolean
}

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

// Only network failures (undici throws TypeError) are retried — Next's control-flow errors must propagate untouched
export const fetchWithRetry = async (
  url: string,
  init: RequestInit,
  { delaysMs: [delay, ...nextDelaysMs], shouldRetryResponse }: FetchRetryOptions,
): Promise<Response> => {
  if (delay === undefined || init.signal?.aborted) {
    return fetch(url, init)
  }

  const res = await fetch(url, init).catch((error: unknown) => {
    if (!(error instanceof TypeError) || init.signal?.aborted) {
      throw error
    }
    console.warn(`Fetch failed for ${url}, retrying in ${delay} ms`, error)
    return null
  })

  if (res && !shouldRetryResponse(res)) {
    return res
  }

  if (res) {
    console.warn(`${url} responded ${res.status}, retrying in ${delay} ms`)
  }

  await wait(delay)
  return fetchWithRetry(url, init, { delaysMs: nextDelaysMs, shouldRetryResponse })
}
